import { mapState } from "vuex";
export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapState(["loginData", "imgDomain"]),
        jurisdictionMenu () {
          let newArr = [],group = this.loginData.group || {};
          let rules_url = [];
          try {
          rules_url = group.rules_url || [];
          } catch (error) {
            return []
          }
          let rules_name = group.rules_name || [];
          rules_url.forEach((e, idx) => {
            newArr.push({
              name: e,
              title: rules_name[idx] || ''
            })
          });
          return newArr
        },
      },
      methods:{
        joinImgUrl(url) {
          let reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
          if (!reg.test(url)) {
            return this.imgDomain + '/' + url
          } else {
            return url
          }
        },
        isJurisdiction(key) {
          // return true;
          return !!this.jurisdictionMenu.filter(e => e.name == key).length;
        },
        verificationPushContentErr(e) {
          // "文本","图片","资料","文章","海报","链接","小程序", "视频"
          // type: e.type,
          //   textContent: "",
          //   content: {
          //     uuid: "", // 资料/文章/海报 的uuid
          //     cover: "", // 资料/文章/链接 封面
          //     title: "", // 资料/文章/链接 标题
          //     description: "", // 描述，无描述的传空字符串即可
          //     link: "" // 跳转链接（type=6时传入）其他传空字符串
          if (e) {
            if(!e.type) {
              return '未选内容类型';
            }
            if ((e.type == 1 || e.type == 2 || e.type == 8) && !e.textContent) {
              return '文本 ， 图片, 视频为空';
            }
            if ((e.type == 3 || e.type == 4 || e.type == 5) && !e.content.uuid) {
              return '没有选择内容';
            }
            if ((e.type == 6) && (!e.content.cover || !e.content.title || !e.content.link)) {
              return '链接填写不全';
            }
            return '';
          }
          return '';
        }
      }
    })
  }
}